import { render, staticRenderFns } from "./wxpay.vue?vue&type=template&id=abe3ca2e&scoped=true"
import script from "./wxpay.vue?vue&type=script&lang=js"
export * from "./wxpay.vue?vue&type=script&lang=js"
import style0 from "./wxpay.vue?vue&type=style&index=0&id=abe3ca2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe3ca2e",
  null
  
)

export default component.exports